'use strict'

export default class About {
    constructor() {
        this.content = $('.contentAbout');
        this.createEvents();
        this.hide();
    }
    show(part='3') {
        this.content.insertBefore($('.questions'));
        this.content[0].style.display = 'flex';
        this.showEvents(part);
    }
    hide() {
        this.content.detach();
    }
    createEvents() {
        $('.contentAbout .btn_content').click((e) => {
            const part = $(e.currentTarget).attr('data-target-index');
            window.staticEvents.emit('navigate',`about/${part}`);
            //this.showEvents($(e.currentTarget).attr('data-target-index'));
        });
    }
    showEvents(index) {
        const targetClass = `type_${index}`; 
        const targets = $(`.vita_event.${targetClass}`);
        const nonTargets = $(`.vita_event:not(.${targetClass})`);
        const speed1 = 0;
        const speed2 = 0;
        nonTargets.stop(true).animate({
            opacity: '0',
            //overflowY: 'hidden',
            //maxHeight: '0px'
        },speed1);
        targets.stop(true).animate({
            opacity: '1',
            //overflowY: 'hidden',
            //maxHeight: '500px'
        },speed1);
        targets.slideDown(speed2);
        nonTargets.slideUp(speed2);
        $('.vita_event.last').removeClass('last');
        targets.last().addClass('last');
        $('.sub1_s').removeClass('active');
        $(`.sub1_s.sub1_${index}`).addClass('active');
    }
}
